<div class="content">
  <h2>Unit Tagging — Help</h2>
  <div class="help-body">
    <p>This screen manages tag data for every configured unit on the quote or order. Each row is one unit.</p>
    <section>
      <h3>Columns</h3>
      <ul>
        <li>
          <strong>Line #, Part #, Seq</strong>
          — read-only identity columns. They are frozen on the left so they stay visible as you scroll right.
        </li>
        <li>
          <strong>Reference, Location</strong>
          — free text printed on the shipping tag (max 24 and 16 characters - only shown when Include Shipping Tags is checked).
        </li>
        <li>
          <strong>Tag, Riser, Floor, Room, Bldg, PO Line</strong>
          — standard unit tagging fields (max 14 / 20 / 5 / 20 / 20 / 5 characters).
        </li>
        <li>
          <strong>Size, Voltage, PO Number, Project, No Tag</strong>
          — checkboxes to control data shown and whether a shipping tag is excluded (only shown when Include Shipping Tags is checked).
        </li>
      </ul>
    </section>
    <section>
      <h3>Sorting &amp; filtering</h3>
      <ul>
        <li>
          Click a column
          <strong>header label</strong>
          to sort by that column. A second click reverses the sort and a third reverts to default sorting.
        </li>
        <li>
          Type in the
          <strong>filter box under any header</strong>
          to filter rows. Matching is case-insensitive and matches anywhere in the value.
        </li>
        <li>
          Multiple filters combine — a row must match
          <strong>all</strong>
          active filters to show.
        </li>
      </ul>
    </section>
    <section>
      <h3>Editing</h3>
      <ul>
        <li>Click a cell and type to edit. Press Enter or Tab to commit.</li>
        <li>
          <strong>Overwrite protection:</strong>
          replacing an existing value in a standard tagging field (Tag, Riser, Floor, Room, Bldg, PO Line) asks you to confirm first. Reference, Location, and the checkboxes never
          prompt.
        </li>
        <li>
          <strong>Fill down:</strong>
          drag the small handle at the bottom-right of a selected cell downward to copy the value to the other units
          <strong>on the same line</strong>
        </li>
        <li>
          <strong>Check / uncheck all:</strong>
          the checkbox in a Size / Voltage / PO Number / Project / No Tag header toggles that flag on every currently-
          <em>filtered</em>
          row at once.
        </li>
      </ul>
    </section>
    <section>
      <h3>Header counts</h3>
      <ul>
        <li>
          <strong>Ship Tag Eligible</strong>
          — number of units that do
          <em>not</em>
          have No Tag checked.
        </li>
        <li>
          <strong>Hi-Rise Eligible</strong>
          — ship-eligible units on a hi-rise product (part number / description contains SM or SG).
        </li>
      </ul>
    </section>
    <section>
      <h3>Toolbar actions</h3>
      <ul>
        <li>
          <strong>Set Reference / Set Location</strong>
          — bulk-fill Reference or Location from another field, a combination of fields, or a value you type — applied to all units or only those still blank (only shown when
          Include Shipping Tags is checked).
        </li>
        <li>
          <strong>Tag Preview</strong>
          — shows how the shipping tag (and, for hi-rise units, the riser tag) will read for a unit; step through units with the arrows or jump to a line (only shown when Include
          Shipping Tags is checked).
        </li>
        <li>
          <strong>Download</strong>
          — export the current tag data to an .xlsx workbook.
        </li>
        <li>
          <strong>Upload</strong>
          — import tag data from an edited .xlsx workbook.
        </li>
        <li>
          <strong>Save Tags</strong>
          — saves all tag data. If a line's unit count changed, you'll get a warning with the option to override and save anyway.
        </li>
      </ul>
    </section>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button class="accent-button" matButton="elevated" (click)="close()">Close</button>
</div>
